import theme from 'config/theme';

export default {
  submenu: {
    position: 'relative',
    marginTop: '4px',
  },
  subMenuItem: (isFirst, isLast) => ({
    padding: '4px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 400,
    marginTop: '1px',
    marginBottom: '1px',
    color: theme.customValues.sidebar.textColor,
    ':hover': {
      color: theme.palette.black.main,
      backgroundColor: theme.customValues.sidebar.bgHover,
    },
    '&.Mui-selected': {
      color: theme.palette.black.main,
      backgroundColor: theme.customValues.sidebar.bgHover,

      ':hover': {
        color: theme.palette.black.main,
        backgroundColor: theme.customValues.sidebar.bgHover,
      },
    },
    '&.Mui-disabled': {
      backgroundColor: theme.palette.lightGray.main,
      opacity: '1',
      '.MuiListItemText-root': {
        opacity: '0.38',
      },
    },
    '&::before': {
      content: "''",
      position: 'absolute',
      left: '28px',
      width: '1px',
      backgroundColor: theme.customValues.sidebar.pseudoElementColor,
      top: isFirst ? 0 : '-8px',
      bottom: isLast ? 0 : '-8px',
    },
  }),
  menuPopover: {
    display: 'flex',
    width: '172px',
    padding: '8px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    zIndex: 9999,
    gap: '4px',
    borderRadius: '12px',
    border: '1px solid rgba(0, 0, 0, 0.10)',
    background: '#FFF',
    boxShadow:
      '0px 100px 80px 0px rgba(0, 0, 0, 0.07), 0px 41.778px 33.422px 0px rgba(0, 0, 0, 0.05), 0px 22.336px 17.869px 0px rgba(0, 0, 0, 0.04), 0px 12.522px 10.017px 0px rgba(0, 0, 0, 0.04), 0px 6.65px 5.32px 0px rgba(0, 0, 0, 0.03), 0px 2.767px 2.214px 0px rgba(0, 0, 0, 0.02)',
  },
  menuItemPopover: {
    padding: '8px 12px',
    color: theme.customValues.sidebar.textColor,
    borderRadius: '8px',
    fontSize: '12px',
    '&:hover': {
      backgroundColor: theme.customValues.sidebar.bgHover,
      color: '#000!important',
    },
  },
};
